//// <reference path="../DataModel.ts" />

namespace ui
{
	export namespace table
	{
		export namespace model
		{

			export interface ITableModelDescriptor
				extends ui.base.IBaseHTMLElementDescriptor
			{
				header?: boolean;
				headerRepeat?: number;
				headerEnd?: boolean;
				style?:
				{
					hover?: boolean;
					border?: boolean;
					stripes?: boolean;
					condense?: boolean;
				};
			}

			export abstract class AbstractTableModel<T>
				extends ui.table.DataModel<T>
			{
				private m_Descriptor: ITableModelDescriptor;

				public constructor( descriptor?: ITableModelDescriptor )
				{
					super();

					this.m_Descriptor	= descriptor || {};

					this.m_Descriptor.classes = this.m_Descriptor.classes || [];

					this.m_Descriptor.classes.splice( 1, 0, 'table' );

					if ( descriptor )
					{
						if ( descriptor.style )
						{
							if ( descriptor.style.hover )
							{
								this.m_Descriptor.classes.push( 'table-hover' );
							}
							if ( descriptor.style.border )
							{
								this.m_Descriptor.classes.push( 'table-bordered' );
							}
							if ( descriptor.style.stripes )
							{
								this.m_Descriptor.classes.push( 'table-striped' );
							}
							if ( descriptor.style.condense )
							{
								this.m_Descriptor.classes.push( 'table-condensed' );
							}
						}
					}
				}

				protected buildHeader(): JQuery<HTMLElement>|null
				{
					return null;
				}

				protected build(): JQuery<HTMLElement>
				{
					const _table			= new ui.base.BaseHTMLElement( 'table' );
					const tbody			= new ui.base.BaseHTMLElement( 'tbody' ).appendTo( _table );
					const header		= this.buildHeader();
					const hrep			= this.m_Descriptor.headerRepeat || 0;

					_table.Initialize( this.m_Descriptor );

					if ( this.m_DataReader )
					{
						this.m_DataReader.GenerateDatafields().forEach(
							( row: JQuery, index: number ): void =>
							{
								if ( header )
								{
									if ( hrep > 0 && index % hrep === 0 )
									{
										tbody.append( header.clone() );
									}
									else if ( index === 0 )
									{
										tbody.append( header.clone() );
									}
								}

								tbody.append( row );
							}
						);
					}

					if ( header )
					{
						tbody.append( header.clone() );
					}

					return _table.Root();
				}
			}

		}
	}
}
